var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsString, Matches } from 'class-validator';
import { CALENDAR_DATE } from './calendar-date.js';
/**
 * Body of
 * `PATCH /v1/office-locations/:officeLocationId/abrechnungsbeauftragung/effective-from`
 * (#1613).
 *
 * An endpoint of its own beside the acceptance, because TM-9636 puts a step-up
 * guard of its own in front of each of the two.
 */
export class ChangeAbrechnungsbeauftragungEffectiveFromDto {
    /** `YYYY-MM-DD`, today or later. Changeable while *entwurf* or *vereinbart*. */
    effectiveFrom;
}
__decorate([
    IsString(),
    Matches(CALENDAR_DATE, { message: 'effectiveFrom must be formatted YYYY-MM-DD.' }),
    __metadata("design:type", String)
], ChangeAbrechnungsbeauftragungEffectiveFromDto.prototype, "effectiveFrom", void 0);
//# sourceMappingURL=change-abrechnungsbeauftragung-effective-from.dto.js.map